import { TRANSACTION_CATEGORY, TRANSACTION_TYPE } from '../../History/types';
import { NotSupportedCategoryIconWrapper, RefundCategoryIconWrapper } from './styles';

type TransactionIconProps = {
  category: TRANSACTION_CATEGORY | TRANSACTION_TYPE.CREDIT;
  translationKey: string;
};

const TransactionIcon = ({ category, translationKey }: TransactionIconProps) => {
  switch (category) {
    case TRANSACTION_CATEGORY.NOT_SUPPORTED:
      return <NotSupportedCategoryIconWrapper />;
    case TRANSACTION_TYPE.CREDIT:
      return <RefundCategoryIconWrapper />;
    default:
      return <img alt={translationKey} src={`/images/icons/${category}-icon.svg`} />;
  }
};

export default TransactionIcon;
